import { IChildrenProps } from '@/typings/children-props'
import { cn } from '@/utils/styles/cn'

interface IInteractiveCitiesSearchListContainerProps extends IChildrenProps {
    className?: string
}

export const InteractiveCitiesSearchListContainer = ({
    children,
    className,
}: IInteractiveCitiesSearchListContainerProps) => {
    return (
        <div
            className={cn(
                'px-4 md:px-0 w-full pt-8 md:pt-14 md:w-[40%] flex 2xl:pr-20 2xl:justify-end justify-center',
                className
            )}
        >
            <div className="w-full md:max-w-[80%] xl:max-w-[450px] flex flex-col">{children}</div>
        </div>
    )
}
